import React from "react";

class TopScrollLink extends React.Component {

  handleClick = (itemid) => {
    this.props.scrollTo(itemid);
  };

  render() {
    const { item } = this.props
    return (
      <div className="summary-link-container">
        <span className="solid_right-icon"></span>
        <div
          onClick={() => this.handleClick(item.itemid)}
          className="top-link-area"
          tabIndex="0"
        >
          {item.categoryName}
        </div>
      </div>
    );
  }
}

export default TopScrollLink;
